module.exports = __webpack_public_path__ + "static/media/bg.8a0211a8.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bg.svg
// module id = 994
// module chunks = 0